import React, { useState, useEffect } from 'react';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const MarketingPlanFormFunds = ({ funds, mpid }) => {
  const [totals, setTotals] = useState({
    added: 0,
    used: 0,
    available: 0,
    used_in_plan: 0
  });

  useEffect(() => {
    var sum = { added: 0, used: 0, available: 0, used_in_plan: 0 };
    funds.forEach(fund => {
      let aux_used_in_plan = 0;
      sum.added += parseFloat(fund.value_currency);
      sum.used += (fund.used*(fund.value_cotacao?parseFloat(fund.value_cotacao):1))
      sum.available += parseFloat(fund.value_currency) - (fund.used*(fund.value_cotacao?parseFloat(fund.value_cotacao):1));
      fund.actionValues.filter(b=>b.action.marketing_plan_id === parseInt(mpid)).forEach(a=>{
        aux_used_in_plan += ((a.actual_value*(fund.value_cotacao?parseFloat(fund.value_cotacao):1)) + (a.funds_expire_value ? (a.funds_expire_value*(fund.value_cotacao?parseFloat(fund.value_cotacao):1) ) : 0))
      });
      sum.used_in_plan += aux_used_in_plan;
    });

    setTotals(sum);
  }, [funds]);

  const { t } = useTranslation();

  const getLocale = (currency) => {
    switch (currency.toString()) {
      case '1':
        return 'BRL';
        break;
      case '2':
        return 'USD';
        break;
      case '3':
        return 'EUR';
        break;
      default:
        break;
    }
  };

  return (
    <Table bordered hover responsive>
      <thead>
        <tr>
          <th className="text-center align-middle">{t('label:type')}</th>
          <th className="text-center align-middle">{'Cotação'}</th>
          <th className="text-center align-middle">{t('label:added')}</th>
          <th className="text-center align-middle">{t('label:used')}</th>
          <th className="text-center align-middle">{t('label:available')}</th>
          <th className="text-center align-middle">
            {t('label:used in plan')}
          </th>
        </tr>
      </thead>
      <tfoot>
        <tr>
          <th className="text-center align-middle">{t('label:total')}</th>
          <th className="text-center align-middle"></th>
          <th className="text-center align-middle">
            {totals.added.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            })}
          </th>
          <th className="text-center align-middle">
            {totals.used.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            })}
          </th>
          <th className="text-center align-middle">
            {totals.available.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            })}
          </th>
          <th className="text-center align-middle">
            {totals.used_in_plan.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            })}
          </th>
        </tr>
      </tfoot>
      <tbody>
        {funds.map((fund, k) => {
          const added = parseFloat(fund.value);
          const used = parseFloat(fund.used);
          var used_in_plan = 0;
          fund.actionValues.filter(b=>b.action.marketing_plan_id === parseInt(mpid)).forEach(a=>{
            used_in_plan += a.actual_value + (a.funds_expire_value ?? 0);
          });
          const available = added - used;
          return (
            <tr key={k}>
              <td className="text-center align-middle">
                {t(`label:${fund.type.name}`)}
              </td>
              <td className="text-center align-middle">
                {fund.value_cotacao?parseFloat(fund.value_cotacao).toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: getLocale(1)
                }):'---'}
              </td>
              <td className="text-center align-middle">
                {added.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: getLocale(fund.type.currency_id)
                })}
              </td>
              <td className="text-center align-middle">
                {used.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: getLocale(fund.type.currency_id)
                })}
              </td>
              <td className="text-center align-middle">
                {available.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: getLocale(fund.type.currency_id)
                })}
              </td>
              <td className="text-center align-middle">
                {used_in_plan.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: getLocale(fund.type.currency_id)
                })}
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default MarketingPlanFormFunds;
